module.exports = __webpack_public_path__ + "img/choose-box-hen.22ea75ed.png";